import { render, staticRenderFns } from "./OFormWrapper.vue?vue&type=template&id=fcb92ef6&scoped=true"
import script from "./OFormWrapper.vue?vue&type=script&lang=js"
export * from "./OFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb92ef6",
  null
  
)

export default component.exports